import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import PwaProvider from "@/contexts/PwaContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import BottomNav from "@/components/BottomNav";
import ViewerBanner from "@/components/account/ViewerBanner";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import AuthMagic from "@/pages/AuthMagic";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Sobre from "@/pages/Sobre";
import { Termos, Privacidade } from "@/pages/Legal";
import OnboardingPersona from "@/pages/OnboardingPersona";
import OnboardingAvatar from "@/pages/OnboardingAvatar";
import AvatarBuilder from "@/pages/AvatarBuilder";
import AvatarReview from "@/pages/AvatarReview";
import AvatarNew from "@/pages/AvatarNew";
import Dashboard from "@/pages/Dashboard";
import AgentChat from "@/pages/AgentChat";
import AvatarLibrary from "@/pages/AvatarLibrary";
import ContentLibrary from "@/pages/ContentLibrary";
// EPIC-20 Studio de Lâminas: DEPRECATED 2026-08-03, movido para a branch remota
// `backlog/epic-20-studio` (implementação completa 20.1-20.4). Ver docs/prd/epic-20.
import Calendar from "@/pages/Calendar";
import Waiting from "@/pages/Waiting";
import Admin from "@/pages/Admin";
import Profile from "@/pages/Profile";
import MinhaMarca from "@/pages/MinhaMarca";

function App() {
  return (
    <div className="app-root">
      <AuthProvider>
        <BrowserRouter>
          <PwaProvider>
          <Toaster
            theme="dark"
            position="top-center"
            // Explícitos de propósito: o default do sonner é implícito e já nos
            // custou uma investigação de "toast que não some".
            duration={4500}
            closeButton
            toastOptions={{
              style: {
                background: "#1A141F",
                color: "#FFFFFF",
                border: "1px solid rgba(255,255,255,0.07)",
                fontFamily: "Manrope, sans-serif",
              },
            }}
          />
          <ViewerBanner />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/sobre" element={<Sobre />} />
            <Route path="/termos" element={<Termos />} />
            <Route path="/privacidade" element={<Privacidade />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/auth/magic" element={<AuthMagic />} />
            <Route path="/esqueci-senha" element={<ForgotPassword />} />
            <Route path="/auth/reset" element={<ResetPassword />} />

            {/* Waiting screen (auth required, no onboarding gate) */}
            <Route
              path="/aguardando"
              element={<ProtectedRoute><Waiting /></ProtectedRoute>}
            />

            {/* Onboarding (protected but no completion gate) */}
            <Route
              path="/onboarding/brand-persona"
              element={<ProtectedRoute><OnboardingPersona /></ProtectedRoute>}
            />
            <Route
              path="/onboarding/avatar"
              element={<ProtectedRoute><OnboardingAvatar /></ProtectedRoute>}
            />
            <Route
              path="/avatars/new"
              element={<ProtectedRoute><AvatarNew /></ProtectedRoute>}
            />
            <Route
              path="/avatars/:id/builder"
              element={<ProtectedRoute><AvatarBuilder /></ProtectedRoute>}
            />
            <Route
              path="/avatars/:id/review"
              element={<ProtectedRoute><AvatarReview /></ProtectedRoute>}
            />

            {/* Full app (requires complete onboarding) */}
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute requireOnboarding>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/agent/brand-persona"
              element={
                <ProtectedRoute requireOnboarding>
                  <Navigate to="/marca" replace />
                </ProtectedRoute>
              }
            />
            <Route
              path="/agent/:slug"
              element={
                <ProtectedRoute requireOnboarding>
                  <AgentChat />
                </ProtectedRoute>
              }
            />
            <Route
              path="/marca"
              element={
                <ProtectedRoute requireOnboarding>
                  <MinhaMarca />
                </ProtectedRoute>
              }
            />
            <Route
              path="/avatars"
              element={
                <ProtectedRoute requireOnboarding>
                  <AvatarLibrary />
                </ProtectedRoute>
              }
            />
            <Route
              path="/library"
              element={
                <ProtectedRoute requireOnboarding>
                  <ContentLibrary />
                </ProtectedRoute>
              }
            />
            <Route
              path="/calendario"
              element={
                <ProtectedRoute requireOnboarding>
                  <Calendar />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <Admin />
                </ProtectedRoute>
              }
            />
            <Route
              path="/perfil"
              element={
                <ProtectedRoute>
                  <Profile />
                </ProtectedRoute>
              }
            />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <BottomNav />
          </PwaProvider>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
